import Dropdown from 'react-bootstrap/Dropdown';
import { ReactElement, useEffect } from 'react';
import DownArrow from '@/assets/img/down-arrow.svg';

export type DropDownProps = {
  data: {
    label: string;
    value: any;
    isSelected?: boolean;
  }[];
  selectedValue?: any;
  placeholder?: string;
  onDismiss: () => void;
  onSelect: (selectedValue: any, index: any) => any;
  icon?: string | ReactElement;
  disabled?: boolean;
};
export const TimeDropdown = ({
  data,
  selectedValue,
  placeholder,
  onDismiss,
  onSelect,
  icon,
  disabled,
}: DropDownProps) => {
  //   const handleSelect = (e: any, event: any) => {
  //     console.log(event);
  //     onSelect(e);
  //   };
  useEffect(() => {}, [selectedValue]);
  return (
    <div className="outer-drop">
      <Dropdown className="new-figma-drop-down">
        <Dropdown.Toggle
          variant="success"
          className="drop-down-btn fixed-width dropdown-toggle"
          id="dropdown-basic"
          disabled={disabled ? disabled : false}
        >
          <div className="btn-selected-text">
            {selectedValue ? selectedValue : placeholder ? placeholder : 'Select'}
          </div>
          <img src={DownArrow} className="down-arrow" />
        </Dropdown.Toggle>
        <Dropdown.Menu className="Duration-drop-down">
          <div className="menu-scroller">
            {data?.map((item, index) => {
              return (
                <Dropdown.Item
                  key={index}
                  onClick={() => {
                    onSelect(item, index);
                  }}
                  eventKey={item.value}
                >
                  <div className="menu-item-minutes">{item.label}</div>
                </Dropdown.Item>
              );
            })}
          </div>
        </Dropdown.Menu>
      </Dropdown>
    </div>
  );
};
